import { NgModule }     from '@angular/core';
import { RouterModule } from '@angular/router';

import InventoryMain from './inventory-main.component';
import { InventoryLanding } from
    '../../components/inventory-main/inventory-landing/inventory-landing.component';

import Organization from '../../components/compute/compute-vcd/organization/organization.component';
import Vdc from '../../components/compute/compute-vcd/vdc/vdc.component';
import NotFound from '../../../common/not-found/not-found.component';
import { AuthGuard } from '../../auth/auth.guard';
import { CanDeactivateGuard }    from '../../auth/can-deactivate-guard.service';
import Vapp from '../../components/compute/compute-vcd/vapp/vapp.component';
import Vm from '../../components/compute/compute-vcd/vm/vm.component';
import VAppGrid from '../../components/compute/compute-vcd/vapp-grid/vapp-grid.component';
import { DirectConnect } from '../network/direct-connect/direct-connect';
import { DirectConnectDetail } from '../network/direct-connect/direct-connect-detail';
import { Gateways } from '../network/gateways/gateways';
import { OrgVdcNetworks } from '../network/org-vdc-networks/org-vdc-networks';
import { OrgVdcNetworkDetail } from '../network/org-vdc-networks/org-vdc-network-detail';
import { NetworksLanding } from '../network/networks-landing.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            { path: 'inventory', component: InventoryMain, canActivate: [AuthGuard], children: [
                { path: '', component: InventoryLanding },
                { path: 'org/:id1', component: Organization },
                { path: 'org/:id1/vdc/:id2', component: Vdc },
                { path: 'org/:id1/vdc/:id2/vapp/:id3', component: Vapp},
                { path: 'org/:id1/vdc/:id2/vapp/:id3/vm/:id4', component: Vm },
                { path: 'networks', component: NetworksLanding },
                { path: 'networks/directconnects', component: DirectConnect},
                { path: 'networks/directconnect/:name', component: DirectConnectDetail},
                { path: 'networks/gateways', component: Gateways},
                { path: 'networks/gateway/:id', component: Gateways},
                { path: 'networks/vdcnetworks', component: OrgVdcNetworks},
                { path: 'networks/vdcnetwork/:id', component: OrgVdcNetworkDetail},
                { path: '**', component: NotFound }
            ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
    ]
})
export class InventoryRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/inventory-main/inventory-routing.module.ts